define.alias("ember-power-select/components/power-select-multiple/trigger", "preview-grid/components/power-select-multiple/trigger");